/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export interface IAccountOrganizationUsersTileDescription {
    description: string;
}

export const AccountOrganizationUsersTileDescription: React.FC<IAccountOrganizationUsersTileDescription> = ({ description }) => (
    <p className='ms-account-organization-users-tile__description'>{description}</p>
);
